<template>
    <div class="verification">
        <a-input :class="{'input-type':inputType==1}" class="code-input" v-model.trim="verificationCode" type='number' autocomplete="off" placeholder="请输入验证码" />
        <a-button type="primary" ghost v-if="!ifCount" @click="getVeificationCode" class="number-code">获取验证码</a-button>
        <a-button class="count-data" v-if="ifCount" type="primary" disabled>
        {{countNum}}s后重新获取
        </a-button>
    </div>
</template>

<script>
export default {
    data(){
        return{
            countNum: 60,
            ifCount: false,
            timer: null,
            verificationCode: undefined,
            inputType: 0,
        }
    },
    props:{
        message: {
            type: Object,
            required: true,
        }
    },
    methods: {
        getVeificationCode() {
            if(this.message.bindedPhoneNum != null&&this.message.bindedPhoneNum != ''){
                this.ifCount = true
                this.timer = setInterval(()=>{
                    this.countNum -- 
                    if(this.countNum == 0){
                        clearInterval(this.timer)
                        this.countNum = 60
                        this.ifCount = false
                    }
                },1000)
                this.axios.post('/api/verifyCode', {
                    type: this.message.type,
                    phone: this.message.bindedPhoneNum,
                })
                .then(response=> {
                    if(response.data.code == 0){
                        this.$message.success('已发送')
                    }else{
                        this.$message.error(response.data.userTip);
                        if(response.data.code == 'A0200'){
                            this.$router.push("/Login")
                        }
                    }
                })
                .catch(error=> {
                    console.log(error);
                });
            }else{
                this.$message.error('请先输入手机号码')
            }
        },
        onAgain() {
            this.$message.error('请再次尝试')
            this.$refs.slideblock.reset();
        },
    },
    mounted: function() {
        if(this.message.inputType == 1){
            this.inputType = 1
        }
    }
}
</script>
<style scoped lang="less">
    .verification{
        margin-bottom: 32px;
        display: flex;
        height:100%;
        .number-code{
            display: inline-block;
            // background: rgba(24, 144, 255, 0.1);
            // border: 1px solid rgba(24, 144, 255, 1);
            color: rgba(58, 220, 255, 1);
            border-radius: 4px;
            text-align: center;
            margin-left: 11px;;
            height:100%;
            padding-left: 0px;
            padding-right: 0px;
            width: 96px;
        }
        .code-input{
            flex: 1;
            height:100%;
            border: none;
            background: rgba(240, 242, 243, 0.5);
        }
        .count-data{
            margin-left: 11px;
            width: 96px;
            // color: rgba(58, 220, 255, 1);
            text-align: center;
            height: 100%;
            padding-left: 0px;
        }
        .input-type{
            border: 1px solid rgba(121, 136, 155, 0.3);
            background: #fff;
        }
    }

</style>
